var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":_vm.pathD,"fill":"none","stroke":_vm.strokeColour,"stroke-width":_vm.strokeWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }